var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseSection',{attrs:{"title":_vm.$t('instance.edit.cards.title'),"icon":"mdi-card-account-details"}},[_c('CardAuthList',{attrs:{"applications":_vm.instance.applications || []},on:{"update:applications":function($event){return _vm.$emit('update:instance', { applications: $event })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }